module.exports = new __parcel__URL__("dps_icon_large.a9cabcfb.png").toString();